import Vue from "vue";
import VueRouter from "vue-router";
import { getInstance } from "../auth0-plugin";

import authRoutes from "@/_auth/authRoutes";
import FinancialRoutes from "@/_backoffice/_financial/router/index.js"
import RegisterRoutes from "@/_backoffice/_registrations/router/index.js"
import CreateOrderRoutes from "@/router/modules/CreateOrderRoutes.js"
import ClientOrderRoutes from "@/_backoffice/_client_order/router/index.js"
import SellerHomeRoutes from "./modules/SellerHomeRoutes";
import store from '../store/index.js'



Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../pages/Home.vue"),
    meta: {
      auth: true
    }
  },
  {
    path: "/home",
    name: "HomeView",
    component: () => import("@/components/homepage/HomeView.vue"),
    meta: {
      auth: true
    }
  },
  {
    path: "/seller_page",
    name: "SellerPage",
    component: () => import("@/components/homepage/SellerView.vue"),
    meta: {
      auth: true,
      roles: ['Seller','Director'],
    }
  },
  {
    path: "/settings",
    name: "SystemFlags",
    component: () => import("@/pages/SystemFlags.vue"),
    meta: {
      auth: true,
      roles: ['Director']
    }
  },
  {
    path: "/data_export",
    name:"DataExport",
    component: () => import("@/pages/DataExports.vue"),
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst']
    }
  },
  ...authRoutes,
  ...FinancialRoutes,
  ...RegisterRoutes,
  ...CreateOrderRoutes,
  ...ClientOrderRoutes,
  ...SellerHomeRoutes
];

Vue.router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

async function Auth0Guard (to, from, next) {
  document.title = 'Gestão - WebCimentão'
  const auth0 = getInstance()

  const guardAction = () => {
    if( !to.meta || !to.meta.auth){
      if (to.meta.auth == false && auth0.isAuthenticated ){
        next('/')
      } else {
        next()
      }
    }else{
      if(auth0.isAuthenticated){
        requireAuth(to, from, next)
      }else{
        next('/login')
      }
    }
  };
  if (!auth0.isLoading) {
    return guardAction();
  }
  auth0.$watch("isLoading", (isLoading) => {
    if (isLoading === false) {
      return guardAction();
    }
  });
}

function requireAuth (to, from, next) {
	function proceed () {
    let my_role = ''
    try {
      my_role = store.state.App.viewAsRoleName ||
        store.state.User.oneUser.included[0].attributes.role.data[0].attributes.name
    } catch (e) {
    }
    if (my_role.includes("Analyst") || my_role.includes("Exec") || my_role.includes("Man") || my_role.includes("Dir") || my_role.includes("Fin") || my_role.includes("Clerk")){
      if (to.meta.roles && to.meta.roles.includes(my_role)){
        next()
      } else if (!to.meta.roles){
        next()
      } else {
        alert("Desculpe, mas parece que você nao tem permissão para acessar esse recurso")
        next(false)
      }
    } else if (my_role.includes('Sel')){
      if (to.meta.roles && to.meta.roles.includes(my_role)){
        next()
      }else if (!to.meta.roles){
        next()
      }  else {
        alert("Desculpe, mas parece que você nao tem permissão para acessar esse recurso")
        next(false)
      }
    } else if (my_role.includes('Log') || my_role.includes('Yard')){
      if (to.meta.roles && to.meta.roles.includes(my_role)){
        next()
      } else if (to.path.includes('approve')){
        next()
      } else {
        alert("Desculpe, mas parece que você nao tem permissão para acessar esse recurso")
        next(false)
      }
    }  
	}

	if ( to.path != '/' && !store.state.User.oneUser && !store.state.User.oneUser?.included ) {
		store.watch(function(){
			if( store.state.User.oneUser ){
				proceed();
			}
		});
	} else {
    if (to.path == '/'){
      next()
    }else{
      store.watch(function(){
        if( store.state.User.oneUser ){
          proceed();
        }
      });
    }
	}
}


Vue.router.beforeResolve((to, from, next) => {
  Auth0Guard(to, from, next)
})

export default Vue.router;
